// src/components/admin_panel/AdminLogin.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import memberstackDOM from "@memberstack/dom";
import { getMemberstackKey } from "../../utils";
import useNoIndex from "../../hooks/useNoIndex";

const currentKey = getMemberstackKey();
const memberstack = memberstackDOM.init({ publicKey: currentKey });

const AdminLogin = () => {
  const navigate = useNavigate();

  // Prevent search engines from indexing this admin-only page
  useNoIndex();

  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleLogin = async (event) => {
    event.preventDefault();
    setLoading(true);
    setErrorMessage("");

    const email = document.getElementById("email").value;
    const password = document.getElementById("password").value;

    try {
      // 1. Log in with the DOM-based Memberstack method
      const response = await memberstack.loginMemberEmailPassword({
        email: email,
        password: password,
      });

      // 2. Extract the token
      const token = response?.data?.tokens?.accessToken;
      if (!token) {
        setErrorMessage("No access token returned. Not logged in as admin.");
        return;
      }

      // 3. Verify admin with your Flask server
      const verifyResponse = await fetch("/admin/verify", {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
        credentials: "include",
      });

      if (verifyResponse.ok) {
        // The server confirmed admin status

        // 4. Store the token so AdminPanel can retrieve it
        localStorage.setItem("memberstackToken", token);

        // 5. Navigate to admin panel
        navigate("/admin/panel");
      } else {
        // Not an admin or token invalid
        const errData = await verifyResponse.json();
        console.error("Admin verification failed:", errData);
        setErrorMessage("You are not authorized as an admin.");
      }
    } catch (error) {
      console.error("Error logging in:", error);
      setErrorMessage("An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-wrapper">
      <main className="main-wrapper">
        <section className="section_hero">
          <div className="padding-global padding-section-large">
            <div className="container-large">
              <div className="hero_card is-vertical">
                <h2 className="hero_heading-text text-align-center margin-bottom margin-small">
                  Admin Log In
                </h2>
                <div className="custom-modal">
                  <div className="modal-content">
                    <form onSubmit={handleLogin}>
                      <label htmlFor="email">Email Address</label>
                      <input
                        className="hero_form-textfield w-input"
                        type="email"
                        id="email"
                        name="email"
                        required
                      />

                      <label htmlFor="password">Password</label>
                      <input
                        className="hero_form-textfield w-input"
                        type="password"
                        id="password"
                        name="password"
                        required
                      />

                      {errorMessage && (
                        <p className="error-message" style={{ color: "red" }}>
                          {errorMessage}
                        </p>
                      )}

                      <button
                        type="submit"
                        className="button-2 is-black w-button"
                        disabled={loading}
                      >
                        {loading ? "Logging In..." : "Log In"}
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default AdminLogin;
